import { dependencies } from '@pn/core/dependencies';
import type { MapMode } from '@pn/core/domain/map';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { mapSlice } from './mapSlice';

export const useMapStorage = () => {
  const { name, getInitialState } = mapSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isInitialized: useSliceSelector((state) => state.isInitialized),
    mapMode: useSliceSelector((state) => state.mapMode),
  };
};

export const mapActions = () => {
  const { dispatch } = dependencies.store;
  const { actions } = mapSlice;

  return {
    initialize: () => dispatch(actions.initialize()),
    updateMode: (mode: MapMode) => dispatch(actions.updateMode(mode)),
    reset: () => dispatch(actions.reset()),
  };
};
